// extracted by mini-css-extract-plugin
export default {"wrapper":"shortAddressWithMap_wrapper__iF8Ky","address":"shortAddressWithMap_address__x2I-3","showOnMap":"shortAddressWithMap_showOnMap__COyGP"};